import { BaseControlBehaviour } from '../BaseControlBehaviour';
import { ExternalScriptWidgetController } from '../../../Widgets/WidgetController';

export class WidgetBehavior extends BaseControlBehaviour {
    private _defaultConfig = {
        update: {
            url: null,
            type: null,
            interval: null,
        },
        controller: null,
        scripts: {
            install: 'javascript:void(0);',
            beforeupdate: 'javascript:void(0);',
            afterupdate: 'javascript:void(0);',
            updatefailed: 'javascript:void(0);',
        },
    };
    constructor() {
        super('widget');
    }

    protected getControllerClass(controllerClass: string) {
        return eval(controllerClass);
    }
    protected installBehaviour(element: HTMLElement): void {
        const config = Utils.getObjectByAttributes(
            this.getFullTag(),
            element,
            null,
            $.extend(true, {}, this._defaultConfig)
        );

        var controllerClass = null;
        if (config.controller) {
            var controllerClass = this.getControllerClass(config.controller);
        } else {
            controllerClass = new ExternalScriptWidgetController(
                element,
                config
            );
        }
        const controller = new controllerClass(element, config);
        $(element).data('controller', controller);
        controller.install();
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.WidgetBehavior = WidgetBehavior;